import cn from '../modules/cn'

export default function BackgroundBubble() {
  return (
    <div
      className={cn(
        'bg-gray-50 w-full h-full fixed left-0 top-0 z-[-10]',
        'after:content-[""] after:absolute after:w-[944px] after:h-[944px] after:rounded-[473px] after:bg-white/50',
        'after:left-[-261px] after:top-[-661px]',
      )}
    />
  )
}
